























import { defineComponent } from "@vue/composition-api";
import { isSameDay, parseISO } from "date-fns";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import { applyOnElement } from "@/lib/elementHelpers";
import { formatDate } from "@/lib/time";
import { BlockingStatus } from "@/types";
import InfiniteScroll from "@/components/InfiniteScroll";
import MessageItem from "@/components/MessageItem";

export default defineComponent({
  name: "MessageList",
  components: { MessageItem, InfiniteScroll },
  props: {
    messages: { type: Array as () => Message[], required: true },
    minUnreadMessageId: { type: String, required: true },
    opponentMinUnreadMessageId: { type: String, required: true },
    enableScroll: { type: Boolean, default: false },
    userId: { type: String, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
    blockingStatus: { type: Object as () => BlockingStatus, required: true },
  },
  computed: {
    observer(): IntersectionObserver {
      return new IntersectionObserver(this.onObserve, {
        rootMargin: "-64px 0px -56px 0px",
      });
    },
  },
  destroyed() {
    this.stopObserve();
    this.observer && this.observer.disconnect();
  },
  methods: {
    date(date: string) {
      return formatDate(new Date(date), { month: "long", day: "2-digit", year: "numeric" });
    },

    isNextDayMessage(messages: Message[], index: number) {
      if (index === 0) return true;
      return !isSameDay(parseISO(messages[index - 1].time), parseISO(messages[index].time));
    },

    isUnreadMessage(message: Message) {
      if (this.minUnreadMessageId === "0") return false;
      return Number(message.id) >= Number(this.minUnreadMessageId);
    },

    async setObserve({ el }: { el: Element }) {
      this.observer.observe(el);
    },

    stopObserve() {
      const observer = this.observer;
      if (this.$refs.unreadMessages && observer) {
        applyOnElement(this.$refs.unreadMessages, el => {
          if (el instanceof Element) observer.unobserve(el);
        });
      }
    },

    onObserve(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
      entries.forEach(entry => {
        if (entry && entry.isIntersecting) {
          const id = Number(entry.target.id.split("message-")[1]);
          const minUnreadMessageId = Number(this.minUnreadMessageId);
          if (minUnreadMessageId > 0 && minUnreadMessageId <= id) {
            const latestReadMessage = this.messages.find(message => message.id === id.toString());
            latestReadMessage && this.$emit("markRead", latestReadMessage);
          }
          observer.unobserve(entry.target);
        }
      });
    },
  },
});
